import commonTableColumns from '@root/components/table/commonTableColumns';
import DateFormatPipe from '@root/components/utilities/DateFormatPipe';
import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import { Button } from '@root/components/v3/button';
import MuitoolTip from '@root/components/Tooltip/materialUiTooltip';
import { PencilIcon } from 'lucide-react';

export const SuppressedColumns = (
  handleModifyJustification,
  hoverRowEdit,
  setHoverRowEdit,
  // deleteSuppressedEvents,
  editSuppressedEvents,
) => {
  return [
    commonTableColumns.environment('environment'),
    {
      field: 'rule_id',
      headerName: 'Master Rule ID',
      minWidth: 200,
      renderCell: params => {
        return params.value || '-';
      },
    },
    {
      field: 'threat_name',
      minWidth: 350,
      headerName: 'Threat Name',
      sort: true,
      renderCell: params => {
        return params.value || '-';
      },
    },
    {
      field: 'created_by',
      headerName: 'Action By',
      minWidth: 300,
      renderCell: params => {
        return params.value || '-';
      },
    },
    {
      field: 'justification_status',
      headerName: 'Action Type',
      minWidth: 300,
      renderCell: params => {
        if (!params.value) return '-';
        return params.value === 'dismiss' ? 'Dismissed' : params.value === 'resolve' ? 'Resolved' : params.value;
      },
    },
    {
      field: 'cluster',
      headerName: 'Cluster',
      minWidth: 200,
      renderCell: params => {
        return params.value || '-';
      },
    },
    {
      field: 'namespace',
      headerName: 'Namespace',
      minWidth: 200,
      renderCell: params => {
        return params.value || '-';
      },
    },
    {
      field: 'pod_name',
      headerName: 'Pod',
      minWidth: 300,
      renderCell: params => {
        return params.value || '-';
      },
    },
    {
      field: 'justification_reason',
      headerName: 'Justification',
      minWidth: 450,
      renderCell: params => {
        return (
          <Tooltip title={params.row.justification_reason}>
            <Text font="regular" className="SingleLine">
              {params.row.justification_reason}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      field: 'justification_received_time',
      headerName: 'Date/Time',
      minWidth: 200,
      renderCell: params => {
        return params.value ? DateFormatPipe(params.value) : '-';
      },
    },
    {
      field: '',
      headerName: '',
      width: 200,
      renderCell: params => (
        <div style={{ display: 'flex', gap: '20px' }}>
          <MuitoolTip label={!editSuppressedEvents && `No permission available. Please contact Organization Admin`}>
            <Button
              disabled={!editSuppressedEvents}
              variant={'outline'}
              className="text-[#1a202c]"
              data-testid="click-k8s-pages-actionhistory-suppressedcolumns-108"
              data-clickable="true"
              onClick={() => handleModifyJustification(params.row)}
              onMouseEnter={() => setHoverRowEdit(params.row)}
              onMouseLeave={() => setHoverRowEdit('')}>
              <PencilIcon className="w-4 h-4" /> Edit
            </Button>
          </MuitoolTip>
        </div>
      ),
    },
  ];
};
